import { render } from "./Loader.vue?vue&type=template&id=cc4dd0c2&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=cc4dd0c2&scoped=true&lang=scss"

import exportComponent from "/Users/jakubluszczek/Documents/Projekty/honesty-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc4dd0c2"]])

export default __exports__